<template>
    <div>
        <div class="left-sidebar ex-bg-pink">
            <nav class="navbar">
                <!-- Links -->
                <ul class="navbar-nav align-items-center">
                    <li class="nav-item">
                        <router-link class="nav-link" :to="{path:'/admin/users'}" refresh>
                            {{ $t('sidebar_admin.users') }}
                        </router-link>
                    </li>
                    <li class="nav-item" v-if="utils.isSystemAdmin()">
                        <router-link class="nav-link" :to="{path:'/admin/groups'}" refresh>
                            {{ $t('sidebar_admin.groups') }}
                        </router-link>
                    </li>
                    <li class="nav-item" v-if="utils.isSystemAdmin()">
                        <router-link class="nav-link" :to="{path:'/admin/companies'}" refresh>
                            {{ $t('sidebar_admin.companies') }}
                        </router-link>
                    </li>
                    <li class="nav-item" v-if="utils.isSystemAdmin()">
                        <router-link class="nav-link" :to="{path:'/admin/dmos'}" refresh>
                            {{ $t('sidebar_admin.dmos') }}
                        </router-link>
                    </li>
                    <li class="nav-item" v-if="utils.isSystemAdmin()">
                        <router-link class="nav-link" :to="{path:'/admin/doc'}" refresh>
                            {{ $t('sidebar_admin.doc') }}
                        </router-link>
                    </li>
                    <li class="nav-item" v-if="utils.isSystemAdmin()">
                        <router-link class="nav-link" :to="{path:'/admin/ocr'}" refresh>
                            {{ $t('sidebar_admin.ocr') }}
                        </router-link>
                    </li>
                    <li class="nav-item" v-if="utils.isSystemAdmin()">
                        <router-link class="nav-link" :to="{path:'/admin/info'}" refresh>
                            {{ $t('sidebar_admin.info') }}
                        </router-link>
                    </li>
                </ul>
            </nav>
        </div>
    </div>
</template>

<script>
import Utils from '@/helpers/utils';

export default {
    name: "PcSideBar",
    data () {
        return {
            utils: Utils,
        };
    }
};
</script>



// WEBPACK FOOTER //
// src/views/layout/pc/SideBar.vue